exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2,h3,h4{font-family:helvetica}div>span,Link>span,p>span{font-family:Metropolis;font-weight:300;font-size:18px}._25o3z{display:block;box-sizing:border-box;margin:0;padding:10px 16px;width:100%;outline:0;border:1px solid #fff;border-radius:4px;color:#484848;text-align:center;text-decoration:none;font-size:18px;line-height:1.3333333;cursor:pointer}._25o3z,._25o3z:hover{background:#00adee}._3n_Fi{border-color:#00adee;background-color:#00adee;color:#fff;font-family:helvetica}.x56Pj{padding:9px 27px}._3n_Fi:active,._3n_Fi:active:focus,._3n_Fi:active:hover,._3n_Fi:focus,._3n_Fi:hover{border-color:#00adee;background-color:#149ce9;color:#fff}._3jGPe{border-color:#00adee;color:#149ce9;background-color:#fff}._3jGPe:active,._3jGPe:active:focus,._3jGPe:active:hover,._3jGPe:focus,._3jGPe:hover{border-color:#00adee;color:#00adee;background-color:#fff}._1s6Va{margin-bottom:6px}.FK2fx{margin-bottom:12px}._13uWB{margin-bottom:18px}.ewvqi{margin-bottom:24px}._2fYM8{margin-bottom:36px}._3rr4T{margin-bottom:48px}.yIxFB{margin-top:6px}._3d-OC{margin-top:12px}._3yHts{margin-top:18px}._2nVrP{margin-top:24px}.NqpC_{margin-top:36px}.AzyFM{margin-top:48px}._104M5{margin:0}._3ANbm{padding:0}._9zR-5{border:0 none!important}._2MF9b{border-radius:50%;border:3px solid #bbb;display:inline-block;width:90px;height:90px}._1lhEe{font-style:normal;font-weight:400;line-height:1}._2MiVE{font-size:3.6em}._2CFyu{color:#767676;height:80px;width:80px}.hsjOt{margin-bottom:6px}._3oHkc{height:45px;border-radius:2px;font-size:14px;border:1px solid #aaa;background-color:#fff;color:#767676}.vf0jd{max-width:530px;margin:0 auto;height:100%;min-height:520px;text-align:center;border:none}._3ypES{position:relative;padding:35px 60px}a,a:active,a:focus,a:hover{color:#008489;text-decoration:none}", ""]);

// exports
exports.locals = {
	"button": "_25o3z",
	"btnPrimary": "_3n_Fi",
	"btnlarge": "x56Pj",
	"btnPrimaryBorder": "_3jGPe",
	"space1": "_1s6Va",
	"space2": "FK2fx",
	"space3": "_13uWB",
	"space4": "ewvqi",
	"space5": "_2fYM8",
	"space6": "_3rr4T",
	"spaceTop1": "yIxFB",
	"spaceTop2": "_3d-OC",
	"spaceTop3": "_3yHts",
	"spaceTop4": "_2nVrP",
	"spaceTop5": "NqpC_",
	"spaceTop6": "AzyFM",
	"noMargin": "_104M5",
	"noPadding": "_3ANbm",
	"noBorder": "_9zR-5",
	"iconContainer": "_2MF9b",
	"iconEnvelope": "_1lhEe",
	"iconSize": "_2MiVE",
	"iconGray": "_2CFyu",
	"formGroup": "hsjOt",
	"formControlInput": "_3oHkc",
	"activationStepPanel": "vf0jd",
	"panelBody": "_3ypES"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Booking/Verification/Verification.css
// module id = 2522
// module chunks = 15